module.exports = {
  MultipleAnswer: {
    PluginName: "Çoktan Çok Seçim",
    content_box_name: "Content ",
    Statement:
      "Çoklu seçimden birden fazla doğru cevabı seçeceğiniz sorudur. Sorunuzu buraya yazınız.",
    Question: "Soru",
    Answer: "Cevap",
    Feedback: "Geri Bildirim",
    FeedbackMsg:
      "Cevap hakkında bir geri dönüş yazabilirsiniz. Bu özelliği araç çubuğundan kapatabilirsiniz.",
    TrueFeedbackMsg:
      '<span class="div-float-left-margin-right-8" ><img><svg id="Layer_1" data-name="Layer 1" height="25" width="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.74 14.85"><defs><style>.cls-1{fill:#31a148;}</style></defs><path class="cls-1" d="M8,19.43H7.89a1.59,1.59,0,0,1-1.29-.73,27.7,27.7,0,0,0-4.89-5.38,1.59,1.59,0,0,1,2-2.46A32.74,32.74,0,0,1,8,15.22,60.13,60.13,0,0,1,20.41,4.83a1.59,1.59,0,1,1,1.73,2.68A53,53,0,0,0,9.23,18.78,1.58,1.58,0,0,1,8,19.43Z" transform="translate(-1.13 -4.57)"/></svg></img></span>Doğru cevap hakkında bir geri dönüş yazabilirsiniz. Bu özelliği araç çubuğundan kapatabilirsiniz.',
    FalseFeedbackMsg:
      '<span class="div-float-left-margin-right-8" ><img><svg id="Layer_2" data-name="Layer 2" height="24" width="24"  xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.3 20.3"><defs><style>.cls-2{fill:#e01f26;}</style></defs><path class="cls-2" d="M20,22.15a2.15,2.15,0,0,1-1.51-.62l-16-16a2.13,2.13,0,0,1,3-3L21.53,18.52A2.13,2.13,0,0,1,20,22.15Z" transform="translate(-1.85 -1.85)"/><path class="cls-2" d="M4,22.15a2.13,2.13,0,0,1-1.5-3.63l16.05-16a2.13,2.13,0,0,1,3,3l-16,16.05A2.15,2.15,0,0,1,4,22.15Z" transform="translate(-1.85 -1.85)"/></svg></img></span>Yanlış cevap hakkında bir geri dönüş yazabilirsiniz. Bu özelliği araç çubuğundan kapatabilirsiniz.',
    ShowFeedback: "Geri bildirim mesajı göster",
    Number: "Seçenek Sayısı",
    ShowLettersInsteadOfNumbers: "Numaralama",
    ShowLetters: "Harfler",
    ShowNumbers: "Sayılar",
    QuizColor: "Soru Rengi",
    Color: "Renk",
    correctAnswerFeedback: "Doğru Cevap",
    notCount: "Bu soru puan eklemez",
    None: "Yok",
    notCount: "Bu soru puan eklemez",
    AllowPartialScore: "Kısmi puana izin ver",
    CheckAnswerText: "Cevabı Kontrol Et Düğme Metni",
    TryAgainText: "Tekrar Dene Düğme Metni",
    SeeAnswerText: "Cevabı Gör Düğme Metni",
    ButtonStyle: "Düğme Stili",
    ButtonBackground: "Düğme Arkaplan Rengi",
    ButtonTextColor: "Düğme Metin Rengi",
    ButtonBorderColor: "Düğme Çerçeve Rengi",
    ButtonBorderWidth: "Düğme Çerçeve Kalınlığı",
    ButtonBorderRadius: "Düğme Çerçeve Yarıçapı",
    ButtonPadding: "Düğme İç Boşluğu",
    ButtonFontSize: "Düğme Font Boyutu",
    ButtonFontWeight: "Düğme Font Kalınlığı",
    ButtonHoverBackground: "Düğme Üzerine Gelme Arkaplan Rengi",
    tryAgain: "Tekrar Dene",
    checkAnswer: "Kontrol Et",
  },
};
